/** @jsxImportSource @emotion/react */
import { SelectInput } from 'components/atoms/Select'
import { ChargeSection } from 'components/lab/billingCharge/BillingChargeUpsert'
import { billingClaimStatusOptions } from 'components/lab/billingCharge/consts'
import { BillingNotes, NoteEntity } from 'components/lab/billingNotes/BillingNotes'
import { BillingAttachments } from 'components/lab/billingNotes/BillingAttachments'
import { Field } from 'formik'
import React from 'react'
import { useGetBillingAttachmentsQuery } from 'store/services/billingAttachments'
import { skipToken } from '@reduxjs/toolkit/query/react'
import { BillingNoteDto } from 'store/types'
import { useLabPermission } from 'hooks/useLabPermission'
import { UserPermission } from 'components/lab/user/permissions'

interface Props {
  claimStatusDisabled?: boolean
  chargeId?: string
  notes?: BillingNoteDto[]
  onNotesChange?: () => void
}

export const ChargeCommentsSection = ({
  claimStatusDisabled = false,
  chargeId,
  notes = [],
  onNotesChange,
}: Props) => {
  const canModifyCharge = useLabPermission(UserPermission.MODIFY_BILLING_CHARGES)
  const { data: attachments = [] } = useGetBillingAttachmentsQuery(
    chargeId ? { owner: { type: 'charge', id: chargeId } } : skipToken,
  )

  return (
    <ChargeSection title={'Notes & Attachments'}>
      <div className={'mt-4'}>
        <div
          css={{
            maxWidth: 300,
          }}>
          <label htmlFor="claimStatus">Claim Status</label>
          <Field
            component={SelectInput}
            options={billingClaimStatusOptions}
            name="claimStatus"
            disabled={claimStatusDisabled}
          />
        </div>

        <div className="mt-3">
          <label>Notes</label>
          {chargeId ? (
            <BillingNotes
              notes={notes}
              type={NoteEntity.CHARGE}
              entityId={chargeId}
              onChange={onNotesChange}
            />
          ) : (
            <div className="text-muted font-italic">
              Notes can be added once the charge is saved.
            </div>
          )}
        </div>

        <div className="mt-4">
          <label>Attachments</label>
          {chargeId ? (
            <BillingAttachments
              owner={{ type: 'charge', id: chargeId }}
              attachments={attachments}
              canModify={canModifyCharge}
            />
          ) : (
            <div className="text-muted font-italic">
              Files can be attached once the charge is saved.
            </div>
          )}
        </div>
      </div>
    </ChargeSection>
  )
}
